// extracted by mini-css-extract-plugin
export default {"collapse":"CheckListPositionsTableContent_collapse__5RIGs","thead":"CheckListPositionsTableContent_thead__6hZ6b","dragHandler":"CheckListPositionsTableContent_dragHandler__7Fr9A"};